
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/pricing/[[...skuId]]",
      function () {
        return require("private-next-pages/products/pricing/[[...skuId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/pricing/[[...skuId]]"])
      });
    }
  